import React from "react";

const TablaEntidadAseguradora = ({item, passDataEA}) => {
  const body={
    MENNIT:item.MENNIT,
    MENOMB:item.MENOMB
  }
  const handleOnclickAse=()=>{
    passDataEA(body)
  }
  return (
    <tr className="border-b text-left" >
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        <button
          onClick={handleOnclickAse}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MEestado}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MENNIT}</td>
      <td></td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MENOMB}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MTUDes}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MTNomP}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MPstatus}</td>
      
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MTUCod}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MTCodP}</td>
    </tr>
  );
};

export default TablaEntidadAseguradora;
